import React from "react";
import { Link } from "react-router-dom";
import { PlantusLogo } from "./Logo";
import { FOOTER } from "@/constants/plantusTestIds";

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.container}
      className="bg-forest-900 text-white/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          <div>
            <PlantusLogo color="#F9F8F6" size="md" variant="dark" />
            <p className="mt-5 font-body text-sm leading-relaxed text-white/60 max-w-xs">
              Die App für rechtssichere PSM-Dokumentation, konform mit
              EU 1107/2009, § 11 PflSchG und der Durchführungsverordnung
              (EU) 2023/564.
            </p>
            <p className="mt-5 font-body text-[11px] uppercase tracking-[0.18em] text-white/40">
              Ein Produkt von
            </p>
            <a
              href="https://hoytec-solutions.com"
              target="_blank"
              rel="noreferrer"
              className="mt-1 inline-block font-heading text-sm font-semibold text-white hover:text-terracotta transition"
            >
              Hoytec-Solutions
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-white/50 mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li><a href="#features" className="font-body text-sm text-white/80 hover:text-white transition">Funktionen</a></li>
              <li><a href="#demo" className="font-body text-sm text-white/80 hover:text-white transition">Demo</a></li>
              <li><a href="#faq" className="font-body text-sm text-white/80 hover:text-white transition">FAQ</a></li>
              <li><a href="#contact" data-testid={FOOTER.contact} className="font-body text-sm text-white/80 hover:text-white transition">Kontakt</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-white/50 mb-4">
              Rechtliches
            </h4>
            <ul className="space-y-3">
              <li><Link data-testid={FOOTER.impressum} to="/impressum" className="font-body text-sm text-white/80 hover:text-white transition">Impressum</Link></li>
              <li><Link data-testid={FOOTER.privacy} to="/datenschutz" className="font-body text-sm text-white/80 hover:text-white transition">Datenschutz</Link></li>
              <li><Link to="/agb" className="font-body text-sm text-white/80 hover:text-white transition">AGB</Link></li>
              <li><Link data-testid="footer-konto-loeschen" to="/konto-loeschen" className="font-body text-sm text-white/80 hover:text-white transition">Konto löschen</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-body text-xs text-white/50">
            © {new Date().getFullYear()} Hoytec-Solutions · Plantus. Alle Rechte vorbehalten.
          </p>
          <p className="font-body text-xs text-white/40">
            <a href="https://hoytec-solutions.com" target="_blank" rel="noreferrer" className="hover:text-white transition">
              hoytec-solutions.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
